export default "__VITE_ASSET__11829a90__"